// extracted by mini-css-extract-plugin
module.exports = {"empty":"Deployments_empty__l7ZSO","empty__text":"Deployments_empty__text__yAtte"};